module.exports = __webpack_public_path__ + "img/xcb-subject-item-10-6@2x.3dfa3492.png";